(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .directive('landingSocialLogin', landingSocialLogin);

    landingSocialLogin.$inject = ['$translatePartialLoader', '$translate'];

    function landingSocialLogin($translatePartialLoader, $translate) {
        var directive = {
            restrict: 'E',
            scope: {
                provider: '@ngProvider',
                disabled: '=ngDisabled',
                onButtonClick: '&'
            },
            templateUrl: 'app/account/social/landing-social-login/landing-social-login.html',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope) {

            $translate.refresh();

            scope.click = function() {
                scope.onButtonClick()(scope.provider);
            };
        }

    }
})();
